const SET_COMPANY_REQUEST = 'boardDetailsSearch/SET_COMPANY_REQUEST'
const CLEAR_COMPANY = 'boardDetailsSearch/CLEAR_COMPANY'

const initialState = {
  selectedCompany: null
}

export function fetchSuccess(payload) {
  return {
    type: SET_COMPANY_REQUEST,
    payload,
  }
}

export function clearCompany() {
  return {
    type: CLEAR_COMPANY
  }
}

export function setCompany(object) {
  return (dispatch) => {
    dispatch(fetchSuccess(object))
  }
}

export function unsetCompany() {
  return (dispatch) => {
    dispatch(clearCompany())
  }
}

export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case SET_COMPANY_REQUEST:
      return Object.assign({}, state, {
        selectedCompany: payload
      })
    case CLEAR_COMPANY:
      return Object.assign({}, state, {
        selectedCompany: null
      })
    default:
      return state;
  }
}

